import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withNavigation } from 'react-navigation';
import { translate } from 'react-i18next';
import auth from '@react-native-firebase/auth';
import { Text, StyleSheet, View, Platform, TouchableOpacity } from 'react-native';
import AppleAuth, { appleAuthAndroid } from '@invertase/react-native-apple-authentication';
import { Icon } from "fitbeat.react-native-components";

import SocialAuth from './SocialAuth';
import { handleOnCompleteSocialAuth } from './utils';
import { persistDeepLinkParams, rehydrateDeepLinkParams } from '../../utils/notifications/actions';
import { setSignupError } from '../actions';
import { getConfig } from '../../config';
import { defaultScale } from '../../utils/scaling';
import Theme from '../../theme';

class SocialLogin extends Component {
  onSuccess = async (user, providerId) => {
    const { basicUserInfo, navigation, type, rehydrateDeepLinkParams, setSignupError } = this.props
    await rehydrateDeepLinkParams();
    await handleOnCompleteSocialAuth(
      user, basicUserInfo, navigation.navigate, type, setSignupError);

    if (this.props.onSuccess) {
      this.props.onSuccess(user);
    }
  }

  validationHasPassedForSocialAuth = () => {
    const { socialValidationGuard, type } = this.props;
    if (type === 'link') {
      return true;
    }

    if (!socialValidationGuard) {
      return true;
    }

    const allTermsAccepted = socialValidationGuard();
    if (allTermsAccepted) {
      return true;
    }

    return false;
  }

  onButtonPressOverride = async (onPress) => {
    const { setIsSocialAuthLoading, type, persistDeepLinkParams } = this.props;
    await persistDeepLinkParams();
    if (!this.validationHasPassedForSocialAuth()) {
      return;
    }
    setIsSocialAuthLoading(true);
    if (type === 'link') {
      await this.props.beforeAuth();
    }
    await onPress();
  }

  render() {
    const {
      t,
      style,
      type,
      setIsSocialAuthLoading,
      socialAuthText,
      socialAuthColor = Theme.WHITE,
      iconColor = Theme.BLACK,
    } = this.props;

    const authConfig = getConfig().auth;
    const canUseAppleAuth = Platform.OS === 'web' || (AppleAuth.isSupported || appleAuthAndroid.isSupported);

    return (
      <View style={[styles.container, style]}>
        <Text style={[styles.loginWith, { color: socialAuthColor }]}>{socialAuthText}</Text>
        <SocialAuth
          type={type}
          onSuccess={this.onSuccess}
          setIsSocialAuthLoading={setIsSocialAuthLoading}
          providerId={auth.GoogleAuthProvider.PROVIDER_ID}
          render={onPress => (
            <TouchableOpacity
              style={styles.buttonStyle}
              onPress={async () => await this.onButtonPressOverride(onPress)}>
              <Icon
                style={{ paddingTop: defaultScale(5) }}
                size={defaultScale(30)}
                color={iconColor}
                name={'logo-google'}
              />
            </TouchableOpacity>
          )}
        />
        <SocialAuth
          type={type}
          visible={canUseAppleAuth}
          onSuccess={this.onSuccess}
          setIsSocialAuthLoading={setIsSocialAuthLoading}
          providerId={'apple.com'}
          render={onPress => (
            <TouchableOpacity
              style={styles.buttonStyle}
              onPress={async () => await this.onButtonPressOverride(onPress)}>
              <Icon
                size={defaultScale(30)}
                color={iconColor}
                name={'logo-apple'}
              />
            </TouchableOpacity>
          )}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: defaultScale(30),
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  buttonStyle: {
    width: defaultScale(40),
    height: defaultScale(40),
    borderRadius: 2,
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    alignSelf: 'center',
    textAlignVertical: 'center',
    backgroundColor: Theme.GREY_DARK,
  },
  buttonText: {
    paddingHorizontal: defaultScale(10)
  },
  loginWith: {
    ...Theme.textStyle.heading,
    color: Theme.WHITE,
  },
});

const mapStateToProps = (state) => {
  return {
    basicUserInfo: state.auth.initialUserSetup.basicUserInfo || {},
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    rehydrateDeepLinkParams: () => dispatch(rehydrateDeepLinkParams()),
    persistDeepLinkParams: () => dispatch(persistDeepLinkParams()),
    setSignupError: (error) => dispatch(setSignupError(error)),
  };
};

SocialLogin = connect(mapStateToProps, mapDispatchToProps)(withNavigation(SocialLogin));
export default translate(['auth'], { wait: true })(SocialLogin)
